import AccordionCards from 'components/card/AccordionCards';
import CrystalDetails from 'components/crystal/crystalDetails';
import CrystalModal from 'components/crystal/crystalModal';
import RMAccordian from 'components/customComponents/Controls/RMAccordian';
import React, { useEffect, useState } from 'react';
import { IStyle } from 'Styles';
import {
  useFetchCrystalTrip,
  useCrystalStates,
  useTripCards,
  useClearSelectedCrystals,
} from './hooks';
import { CrystalCard, CrystalsHeader } from './index';
import { useDispatch } from 'react-redux';
import { setSelectedTripId } from 'redux/reducers/synchrotronTripReducer';
import {
  useSelectedDropImageParameters,
  useLastSelectedWellNavigationDetails,
} from 'redux/hooks/experiment';

const TRIP_CARDS_COUNT = 3;
const HarvestCrystal = () => {
  useFetchCrystalTrip();
  const clearSelectedCrystals = useClearSelectedCrystals();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { selectedTripCrystals } = useCrystalStates();
  const [startIndex, setStartIndex] = useState<number>(0);
  const [modalDetails, setModalDetails] = useState({
    showModal: false,
    body: null,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    clearSelectedCrystals(wellNavigationDetails, selectedDropImageParameters);
  }, [wellNavigationDetails, selectedDropImageParameters]);

  const openCrystal = (crystalId: number) => {
    setModalDetails(() => ({
      ...modalDetails,
      showModal: true,
      body: <CrystalDetails crystalId={crystalId} closeModal={closeCrystal} editMode />,
    }));
  };
  const closeCrystal = () => {
    setModalDetails({ body: null, showModal: false });
  };
  const tripCards = useTripCards();

  const nextIndex = () => {
    if (startIndex + TRIP_CARDS_COUNT < tripCards.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const previousIndex = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const renderTripCards = () => {
    let cardProps = [];
    if (tripCards?.length) {
      cardProps = tripCards?.slice(startIndex, startIndex + TRIP_CARDS_COUNT);
    }
    const cards = cardProps.map((card) => (
      <AccordionCards key={`accCard${card.id}`} {...card} />
    ));
    return cards;
  };

  const renderCrystals = () =>
    selectedTripCrystals?.map((crystal) => (
      <CrystalCard
        key={`crystal${crystal.id}`}
        crystal={crystal}
        openCrystal={openCrystal}
      />
    ));

  useEffect(() => {
    if (tripCards?.length === 1) {
      dispatch(setSelectedTripId(0));
    }
  }, [tripCards]);

  return (
    <div id="exp-harvesting-crystal-container" className="container h-[100%]">
      <div id="exp-harvesting-crystal-arcodian" className="accordian h-[8.47%]">
        <RMAccordian
          nextClick={nextIndex}
          preClick={previousIndex}
          style={null}
          className="h-[100%]"
        >
          <div id="exp-harvesting-crystal-rendertripcard" className="flex space-x-2">
            {renderTripCards()}
          </div>
        </RMAccordian>
      </div>
      <hr id="exp-harvesting-crystal-header" style={styles.border} />
      <CrystalsHeader className="6.4%" />
      <div
        id="exp-harvesting-crystal-rendercrystal"
        className="h-[76%] overflow-x-hidden"
        style={styles.crystalsCard}
      >
        {renderCrystals()}
      </div>
      <CrystalModal {...modalDetails} closeModal={closeCrystal} />
    </div>
  );
};
export default HarvestCrystal;
const styles: IStyle = {
  border: {
    borderTop: '1px solid rgba(0,0,0,0.5)',
  },
  crystalsCard: {
    overflow: 'scroll',
    height: '50vh',
    width: '28vw',
  },
};
